<div>
  <!-- SEÇÃO INFORMAÇÕES PRINCIPAIS -->
  <section>
    <p class="section-title">INFORMAÇÕES PRINCIPAIS</p>

    <mat-grid-list cols="4" rowHeight="100px" gutterSize="1em">
      <!-- CNPJ -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>CNPJ</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('cnpj')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('cnpj', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="00.000.000/0000-00"
            mask="00.000.000/0000-00"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Razão Social -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Razão social</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('razaoSocial')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('razaoSocial', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Razão social*"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <!-- Nome Fantasia -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nome fantasia</mat-label>
      <input
        matInput
        [ngModel]="dadosCompartilhados.empresaForm?.get('nomeFantasia')?.value"
        (ngModelChange)="dadosCompartilhados.updateForm('nomeFantasia', $event)"
        [ngModelOptions]="{standalone: true}"
        placeholder="Nome fantasia*"
        required
        [disabled]="this.formBloqueado()"
      />
    </mat-form-field>
  </section>

  <div class="spacer" style="height: 2em"></div>

  <!-- SEÇÃO ENDEREÇO PRINCIPAL -->
  <section>
    <p class="section-title">ENDEREÇO PRINCIPAL</p>

    <mat-grid-list cols="4" rowHeight="100px" gutterSize="1em">
      <!-- CEP -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>CEP</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('cep')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('cep', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="00000-000"
            mask="00000-000"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Logradouro -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Logradouro</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('logradouro')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('logradouro', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Logradouro*"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Número -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Número</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('numero')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('numero', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Número"
            type="number"
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Complemento -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Complemento</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('complemento')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('complemento', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Complemento"
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- UF -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>UF</mat-label>
          <mat-select
            [ngModel]="dadosCompartilhados.empresaForm?.get('ufResidencia')?.value"
            (ngModelChange)="dadosCompartilhados.onChangeUF($event)"
            [ngModelOptions]="{standalone: true}"
            required
            [disabled]="this.formBloqueado()"
          >
            <mat-option value="">Selecione</mat-option>
            <mat-option
              *ngFor="let uf of dadosCompartilhados.ufOptions"
              [value]="uf.id_uf"
            >
              {{ uf.nome }} ({{ uf.sigla }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Cidade -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Cidade</mat-label>
          <mat-select
            [ngModel]="dadosCompartilhados.empresaForm?.get('cidadeResidencia')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('cidadeResidencia', $event)"
            [ngModelOptions]="{standalone: true}"
            [disabled]="this.formBloqueado() || !dadosCompartilhados.empresaForm?.get('ufResidencia')?.value"
            required
          >
            <mat-option value="">Selecione</mat-option>
            <mat-option
              *ngFor="let cidade of cidadeOptionsFiltradas; "
              [value]="cidade.id_cidade"
            >
              {{ cidade.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  <div class="spacer" style="height: 2em"></div>

  <!-- SEÇÃO CONTATO PRINCIPAL -->
  <section>
    <p class="section-title">CONTATO PRINCIPAL</p>

    <mat-grid-list cols="4" rowHeight="100px" gutterSize="1em">
      <!-- Nome Completo -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome completo</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('nomeCompleto')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('nomeCompleto', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Nome completo*"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Email -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="email"
            [ngModel]="dadosCompartilhados.empresaForm?.get('email')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('email', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="email@exemplo.com"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Cargo -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cargo</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('cargo')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('cargo', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="Cargo*"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Telefone -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Telefone celular</mat-label>
          <input
            matInput
            [ngModel]="dadosCompartilhados.empresaForm?.get('telefoneCelular')?.value"
            (ngModelChange)="dadosCompartilhados.updateForm('telefoneCelular', $event)"
            [ngModelOptions]="{standalone: true}"
            placeholder="(00) 00000-0000"
            mask="(00) 00000-0000"
            required
            [disabled]="this.formBloqueado()"
          />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  @if(!this.formBloqueado()) {
  <section
    style="
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 1em;
    "
  >
    <button matButton="outlined" (click)="onCancelar()">Cancelar</button>
    <button matButton="filled" (click)="onSalvar()">Salvar</button>
  </section>
  }
</div>
